import { render } from "./EvalutationQuestionListing.vue?vue&type=template&id=6450e3cb&scoped=true&ts=true"
import script from "./EvalutationQuestionListing.vue?vue&type=script&lang=ts"
export * from "./EvalutationQuestionListing.vue?vue&type=script&lang=ts"

import "./EvalutationQuestionListing.vue?vue&type=style&index=0&id=6450e3cb&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6450e3cb"]])

export default __exports__